module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/udine.c64af8433ccadb07996d8b056e6f6c80.jpg";